import { Pipe, PipeTransform } from '@angular/core';
import { toBoolean } from '@shared/helpers/utils.helper';

@Pipe({
    name: 'getBooleanValue',
})
export class GetBooleanValuePipe implements PipeTransform {
    transform(value: unknown): boolean {
        return toBoolean(value);
    }
}
